"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findSingleRouteExactIn = void 0;
const tines_1 = require("@sushiswap/tines");
const convertPoolOrPairtoRPool_1 = require("./convertPoolOrPairtoRPool");
function findSingleRouteExactIn(from, to, amountIn, pools, baseToken, gasPrice) {
    return (0, tines_1.findSingleRouteExactIn)(from, to, amountIn, pools.map((pool) => (0, convertPoolOrPairtoRPool_1.convertPoolOrPairtoRPool)(pool)), baseToken, gasPrice);
}
exports.findSingleRouteExactIn = findSingleRouteExactIn;
//# sourceMappingURL=findSingleRouteExactIn.js.map